export const ProgrammeType = {
  Anchor: 0,
  YouPlus: 1
}
